import React, { useState, useEffect } from "react";
import Trash from "feather-icons-react/build/IconComponents/Trash";
import { PlusCircle } from "feather-icons-react/build/IconComponents";
import { Offcanvas, Form } from "react-bootstrap";
import apiHandler from "../../common/api";
import { useSelector } from "react-redux";
import moment from "moment";

const StaffRegularShift = ({
  minHoursDropdown,
  daysDropdown,
  resourceData,
  businessId,
  callbackHandelCancle,
}) => {
  const [shifts, setShifts] = useState([]);

  const userData = useSelector((state) => state.user_data);

  const getStaffdayWiseShift = async (bId) => {
    try {
      const { ResponseCode, ResponseData } = await apiHandler({
        method: "GET",
        route: `Business/TeamShiftByDay?businessId=${bId}&resourceId=${resourceData?.resourceId}`,
      });

      if (ResponseCode !== "SUCCESS")
        throw new Error("Failed to fetch team list");

      const finalData = ResponseData?.map((shift, index) => ({
        ...shift,
        indexId: index + 1, // Ensure existing shifts have indexId
      })).sort((a, b) => a.dayId - b.dayId || a.indexId - b.indexId);

      setShifts(finalData);
    } catch (error) {
      console.error("Error fetching team data:", error);
    }
  };

  useEffect(() => {
    if (resourceData && resourceData.resourceId > 0) {
      getStaffdayWiseShift(businessId);
    }
  }, [resourceData]);

  const handleAddShift = (dayId) => {
    const maxIndexId = shifts.length
      ? Math.max(...shifts.map((s) => s.indexId))
      : 0;

    const newShift = {
      id: 0, // New shift gets id 0 for backend processing
      indexId: maxIndexId + 1,
      dayId,
      start: "09:00",
      end: "17:00",
    };

    // Find the last shift of the same day
    const lastSameDayIndex = shifts
      .map((s, index) => ({ ...s, index }))
      .reverse()
      .find((s) => s.dayId === dayId)?.index;

    const updatedShifts = [...shifts];
    if (lastSameDayIndex !== undefined) {
      updatedShifts.splice(lastSameDayIndex + 1, 0, newShift);
    } else {
      updatedShifts.push(newShift);
    }

    // Ensure order remains dayId -> indexId
    setShifts(
      updatedShifts.sort((a, b) => a.dayId - b.dayId || a.indexId - b.indexId)
    );
  };

  const handleShiftChange = (indexId, field, value) => {
    const updatedShifts = shifts.map((s) =>
      s.indexId === indexId ? { ...s, [field]: value } : s
    );
    setShifts(updatedShifts);
  };

  const handleDeleteShift = (indexId) => {
    const updatedShifts = shifts.filter((s) => s.indexId !== indexId);
    setShifts(updatedShifts);
  };

  console.log(shifts, "shiftslist");

  const handleCancel = () => {
    setShifts([]);
    callbackHandelCancle();
  };

  const handleSave = async () => {
    try {
      const payloadData = {
        // ...addEventData,
        shifts,
        businessId,
        // dayId: moment(addEventData?.start).isoWeekday(),
        date: moment().format("YYYY-MM-DD"),
        isDayOff: 0,
        tillDate: "",
        loginuserid: userData?.id,
        staffId: resourceData?.resourceId,
        type: resourceData?.type,
      };

      console.log(payloadData, "payloadData");

      const responseData = await apiHandler({
        method: "POST",
        route: `Business/TeamShiftScheduleUpsert?businessId=${businessId}`,
        payload: payloadData,
      });

      if (responseData?.ResponseCode !== "SUCCESS") {
        console.error("Failed to fetch team list:", responseData);
        return;
      }

      callbackHandelCancle();
    } catch (error) {
      console.error("Error fetching service data:", error);
    }
  };

  return (
    <Offcanvas.Body className="p-4" style={{ width: "600px" }}>
      <Form className="space-y-3">
        {daysDropdown
          .filter((day) => day.isDeleted === 0)
          .map((day) => (
            <div key={day.id} className="">
              <div className="custome-border-bottom d-flex align-items-center gap-2">
                <Form.Check
                  type="checkbox"
                  className="d-flex align-items-center text-color-70 mt-2 gap-2"
                  label={`${day.dayName}`}
                  checked={shifts.some((s) => s.dayId === day.id)}
                  onChange={() =>
                    shifts.some((s) => s.dayId === day.id)
                      ? setShifts(shifts.filter((s) => s.dayId !== day.id))
                      : handleAddShift(day.id)
                  }
                />
                {!shifts.some((s) => s.dayId === day.id) && (
                  <p className="mt-2" style={{ marginLeft: "20px" }}> No Shift</p>
                )}
              </div>

              {shifts
                .filter((s) => s.dayId === day.id)
                .map((shift) => (
                  <div
                    key={shift.indexId}
                    className="d-flex align-items-center gap-3 mt-2"
                  >
                    <Form.Select
                      value={shift.start}
                      onChange={(e) =>
                        handleShiftChange(
                          shift.indexId,
                          "start",
                          e.target.value
                        )
                      }
                    >
                      {minHoursDropdown.map((time, i) => (
                        <option key={i} value={time.value}>
                          {time.label}
                        </option>
                      ))}
                    </Form.Select>

                    <span className="text-color-70">-</span>

                    <Form.Select
                      value={shift.end}
                      onChange={(e) =>
                        handleShiftChange(shift.indexId, "end", e.target.value)
                      }
                    >
                      {minHoursDropdown.map((time, i) => (
                        <option key={i} value={time.value}>
                          {time.label}
                        </option>
                      ))}
                    </Form.Select>
                    {/* 
                    <Trash
                      className="text-danger cursor-pointer"
                      onClick={() => handleDeleteShift(shift.indexId)}
                    /> */}
                    <button
                      onClick={() => handleDeleteShift(shift.indexId)}
                      className="cursor-pointer btn btn-primary btn-sm me-2"
                    >
                      <Trash
                        style={{
                          width: "30px",
                          height: "30px",
                          padding: "4px",
                        }}
                      />
                    </button>
                  </div>
                ))}

              {shifts.some((s) => s.dayId === day.id) && (
                <p
                  className="text-primary mt-2 d-flex align-items-center gap-2"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleAddShift(day.id)}
                >
                  <PlusCircle /> <span>Add a shift</span>
                </p>
              )}
            </div>
          ))}

        <div className="d-flex gap-2 mt-2">
          <div className="d-flex ms-auto">
            <button
              onClick={() => handleCancel()}
              className="btn btn-outline-primary btn-sm me-2 mb-2"
            >
              Cancel
            </button>
            <button
              className="btn btn-primary btn-sm btn-wave me-2 mb-2"
              onClick={() => handleSave()}
            >
              Save
            </button>
          </div>
        </div>
      </Form>
    </Offcanvas.Body>
  );
};

export default StaffRegularShift;
